import { render } from "./EditColor.vue?vue&type=template&id=eefdf2a0&ts=true"
import script from "./EditColor.vue?vue&type=script&lang=ts"
export * from "./EditColor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__